<template>
  <div>
    <!-- <Page2
      style="width: 29.7cm; height: 21cm; border: 1px solid black"
      class="mx-auto"
      id="page2"
      :student="student"
      :ui_setting="ui_setting_page2"
      :selectedLanguageType="selectedLanguageType"
      v-if="ui_setting_page2"
    ></Page2>
    <v-row justify="center" class="my-10" style="margin-top: 240px !important">
      <v-btn @click="_print('page2')" color="secondary" dark>Print2</v-btn>
    </v-row>

    <div style="margin-top: 10px; margin-bottom: 40px">
      <v-card class="px-10 mx-10 mt-10 pb-10">
        <v-row justify="end">
          <v-col cols="6">
            <v-row class="px-10">
              <v-col lg="3" md="3" sm="3">
                <v-select
                  :items="[
                    { name: '1. Монгол xэл', languageType: 1 },
                    {
                      name: '2. Англи xэл',
                      languageType: 2,
                    },
                    {
                      name: '3. Монгол бичиг',
                      languageType: 3,
                    },
                  ]"
                  v-model="selectedLanguageType"
                  item-text="name"
                  item-value="languageType"
                  return-object
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-btn @click="_updateFullScreenPage2" text>
              <v-icon v-if="ui_setting_page2.fullscreenPage2"
                >mdi-fullscreen</v-icon
              >
              <v-icon v-else>mdi-fullscreen-exit</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <template v-if="ui_setting_page2.fullscreenPage2">
          <h2>Diplom Page 2</h2>
          <v-row>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.schoolName"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="schoolName"
              >
              </v-text-field>
            </v-col>

            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.schoolNameEN"
                @input="_updateMarginPage2"
                label="schoolNameEN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.schoolNameMB"
                @input="_updateMarginPage2"
                label="schoolNameMB"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.schoolFontSize"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="School FontSize"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.headY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="headY"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.subTitle"
                @input="_updateMarginPage2"
                label="subTitle"
              >
              </v-text-field>
            </v-col>

            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.subTitleEN"
                @input="_updateMarginPage2"
                label="subTitleEN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.subTitleMB"
                @input="_updateMarginPage2"
                label="subTitleMB"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.subTitleFontSize"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="subTitleFontSize"
              >
              </v-text-field>
            </v-col>

            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.subTitleY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="subTitleY"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.scoreTableX"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="scoreTableX"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.scoreTableY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="scoreTableY"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.scoreTableWidth"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="scoreTableWidth"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.tableLessonFont"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="tableLessonFont"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="background-color: #ffebee">
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.signatureX"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="signatureX"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.signatureY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="signatureY"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="background-color: #e3f2fd">
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText1"
                @input="_updateMarginPage2"
                label="signatureText1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText1EN"
                @input="_updateMarginPage2"
                label="signatureText1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText1MB"
                @input="_updateMarginPage2"
                label="signatureText1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName1"
                @input="_updateMarginPage2"
                label="signatureName1"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName1EN"
                @input="_updateMarginPage2"
                label="signatureName1EN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName1MB"
                @input="_updateMarginPage2"
                label="signatureName1MB"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row style="background-color: #e3f2fd">
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText2"
                @input="_updateMarginPage2"
                label="signatureText2"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText2EN"
                @input="_updateMarginPage2"
                label="signatureText2EN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureText2MB"
                @input="_updateMarginPage2"
                label="signatureText2MB"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName2"
                @input="_updateMarginPage2"
                label="signatureName2"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName2EN"
                @input="_updateMarginPage2"
                label="signatureName2EN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.signatureName2MB"
                @input="_updateMarginPage2"
                label="signatureName2MB"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.diplomPreText"
                @input="_updateMarginPage2"
                label="diplomPreText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.diplomPreTextEN"
                @input="_updateMarginPage2"
                label="diplomPreText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.trim="ui_setting_page2.diplomPreTextMB"
                @input="_updateMarginPage2"
                label="diplomPreText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.diplomPreTextX"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="diplomPreTextX"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.diplomPreTextY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="diplomPreTextY"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.bottomText"
                @input="_updateMarginPage2"
                label="bottomText"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.bottomTextEN"
                @input="_updateMarginPage2"
                label="bottomTextEN"
              >
              </v-text-field>
            </v-col>
            <v-col lg="3" md="3" cols="3">
              <v-text-field
                v-model.trim="ui_setting_page2.bottomTextMB"
                @input="_updateMarginPage2"
                label="bottomTextMB"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.bottomTextX"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="bottomTextX"
              >
              </v-text-field>
            </v-col>
            <v-col lg="auto" md="auto" cols="auto">
              <v-text-field
                v-model.number="ui_setting_page2.bottomTextY"
                type="Number"
                @keydown="_updateMarginPage2"
                @click="_updateMarginPage2"
                label="bottomTextY"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </div> -->
    <Page2MX :student="student"></Page2MX>
    <Page2EN :student="student"></Page2EN>
    <Page2MB :student="student"></Page2MB>
    <PrintComponent
      id="diplomaPage1"
      :student="student"
      :ui_setting="ui_setting"
      v-if="ui_setting"
    ></PrintComponent>
    <v-row justify="center">
      <v-btn @click="_print('diplomaPage1')" color="secondary" dark
        >Print Page1</v-btn
      >
    </v-row>
    <v-card class="px-10 mx-10 mt-10 pb-10">
      <v-row justify="end" class="mt-2 pt-4">
        <v-btn @click="_updateFullScreen" text>
          <v-icon v-if="ui_setting.fullscreen">mdi-fullscreen</v-icon>
          <v-icon v-else>mdi-fullscreen-exit</v-icon>
        </v-btn>
      </v-row>
      <template v-if="ui_setting.fullscreen">
        <v-row>
          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.top1"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="TOP1, 283.46px (Монгол улсын...)"
            >
            </v-text-field>
          </v-col>
          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.top2"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="TOP2, 37.79px (ТТДС...)"
            >
            </v-text-field>
          </v-col>
          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.top3"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="TOP3, 75.59px (Гарын үсэг...)"
            >
            </v-text-field>
          </v-col>
          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.bottom1"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="BOTTOM_1, 94.48px (Бүртгэл...)"
            >
            </v-text-field>
          </v-col>

          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.left1"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="LEFT_1, 117.16px (УБ...)"
            >
            </v-text-field>
          </v-col>

          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.left2"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="LEFT_2 (2023...)"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row style="background-color: #ffebee">
          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.fontSize1"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="fontSize1,16pt (Монгол улсын..."
            >
            </v-text-field>
          </v-col>
          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.fontSize2"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="fontSize2, 16pt (ТТДС...16pt)"
            >
            </v-text-field>
          </v-col>
          <v-col lg="auto" md="auto" cols="auto">
            <v-text-field
              v-model.number="ui_setting.fontSize3"
              type="Number"
              @keydown="_updateMargin"
              @click="_updateMargin"
              label="fontSize3 (Гарын үсэг...12pt)"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row style="background-color: #e3f2fd">
          <v-col lg="12" md="12" cols="12">
            <v-text-field
              v-model.trim="ui_setting.decisionText"
              @input="_updateMargin"
              label="TEXT (шийдвэрийг үндэслэн,..."
            >
            </v-text-field>
          </v-col>
          <v-col lg="12" md="12" cols="12">
            <v-text-field
              v-model.trim="ui_setting.tushaalText"
              @input="_updateMargin"
              label="TEXT(тоот тушаалаар,..."
            >
            </v-text-field>
          </v-col>
          <v-col lg="12" md="12" cols="12">
            <v-text-field
              v-model.trim="ui_setting.printAtDateText"
              @input="_updateMargin"
              label="TEXT (Xүлээнгэн өгөx өдөр,..."
            >
            </v-text-field>
          </v-col>
        </v-row>
      </template>
    </v-card>
    <!-- english -->
    <v-card class="mx-10 my-16 pb-10">
      <v-row>
        <v-col lg="8" md="8" sm="12" class="mt-10">
          <Page1EN
            id="diplomaPage1EN"
            :student="student"
            :ui_setting="ui_setting_page1_eng"
            v-if="ui_setting_page1_eng"
          ></Page1EN>
          <v-row justify="center" class="mt-16">
          
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-card
            class="px-8 mx-10 mt-10 pb-10"
            height="800"
            style="overflow-y: scroll"
          >
            <v-row justify="space-between" class="mt-2 py-4">
              <v-btn @click="_print('diplomaPage1EN')" color="secondary" dark class=""
              >Print Page1 EN</v-btn
            >
              <v-btn
                color="primary"
                @click="_addNewField(ui_setting_page1_eng)"
                >Text+</v-btn
              >
              <v-btn
                @click="_updatePage1ENFullScreen(ui_setting_page1_eng)"
                text
              >
                <v-icon v-if="ui_setting_page1_eng.fullscreen"
                  >mdi-fullscreen</v-icon
                >
                <v-icon v-else>mdi-fullscreen-exit</v-icon>
              </v-btn>
            </v-row>
            <template v-if="ui_setting_page1_eng.fullscreen">
              <v-row
                v-for="(textItem, textItemIndex) in page2Items"
                :key="textItemIndex"
              >
                <v-col
                  lg="12"
                  md="12"
                  cols="12"
                  style="margin-bottom: -40px; margin-top: 15px"
                >
                  <v-text-field
                    v-model="textItem.text"
                    @keydown="_updatePage1EN"
                    @click="_updatePage1EN"
                    :label="textItem.text"
                  >
                  </v-text-field>
                </v-col>
                <v-col lg="3" md="3" cols="3">
                  <v-text-field
                    v-model.number="textItem.x"
                    type="Number"
                    @keydown="_updatePage1EN"
                    @click="_updatePage1EN"
                    label="X"
                  >
                  </v-text-field>
                </v-col>
                <v-col lg="3" md="3" cols="3">
                  <v-text-field
                    v-model.number="textItem.y"
                    type="Number"
                    @keydown="_updatePage1EN"
                    @click="_updatePage1EN"
                    label="Y"
                  >
                  </v-text-field>
                </v-col>
                <v-col lg="3" md="3" cols="3">
                  <v-text-field
                    v-model.number="textItem.fontSize"
                    type="Number"
                    @keydown="_updatePage1EN"
                    @click="_updatePage1EN"
                    label="FontSize"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-btn
                    style="margin-top: 15px; margin-left: -10px"
                    icon
                    @click="
                      _deleteTextItem(ui_setting_page1_eng, textItemIndex)
                    "
                    ><v-icon small>mdi-delete</v-icon></v-btn
                  >
                </v-col>
                <div
                  style="display: flex; padding-left: 9px; margin-top: -40px"
                >
                  <v-checkbox
                    @click="_updatePage1EN"
                    v-model="textItem.isBold"
                    label="isBold"
                    style="margin-right: 10px"
                  ></v-checkbox>
                  <v-checkbox
                    @click="_updatePage1EN"
                    v-model="textItem.isUppercase"
                    label="isUppercase"
                    style="margin-right: 10px"
                  ></v-checkbox>
                  <v-checkbox
                    @click="_updatePage1EN"
                    v-model="textItem.isVariable"
                    label="isVariable"
                  ></v-checkbox>
                </div>
                <div
                  style="display: flex; padding-left: 9px; margin-top: -20px"
                >
                  <v-text-field
                    style="padding-right: 5px"
                    :disabled="!textItem.isVariable"
                    v-model="textItem.variableName"
                    @keydown="_updatePage1EN"
                    @click="_updatePage1EN"
                    label="variableName"
                  >
                  </v-text-field>
                  <v-text-field
                    style="padding-left: 5px"
                    v-model="textItem.nextVariableName"
                    @keydown="_updatePage1EN"
                    @click="_updatePage1EN"
                    label="nextVariableName"
                  >
                  </v-text-field>
                </div>
              </v-row>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <!-- //mongol bichig -->
    <v-card class="mx-10 my-10">
      <v-row>
        <v-col lg="8" md="8" sm="12" class="mt-10 pb-10">
          <Page1MB
            :student="student"
            :selectedMBCard="selectedMBCard"
          ></Page1MB>
          <v-row justify="center">
        
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-card
            class="px-2 mt-10 pb-10"
            height="800"
            style="overflow-y: scroll"
          >
            <v-row justify="space-between" class="mt-2 py-4">
              <v-btn @click="_print('diplomaPage1MB')" color="secondary" dark class="ml-4"
              >Print Page1MB</v-btn
            >
              <v-btn
                color="primary"
                @click="_addNewField(ui_setting_page1_mb)"
                >Теxт+</v-btn
              >
              <v-btn
                @click="_updatePage1ENFullScreen(ui_setting_page1_mb)"
                text
              >
                <v-icon v-if="ui_setting_page1_mb.fullscreen"
                  >mdi-fullscreen</v-icon
                >
                <v-icon v-else>mdi-fullscreen-exit</v-icon>
              </v-btn>
            </v-row>
            <template v-if="ui_setting_page1_mb.fullscreen">
              <v-card
                elevation="2"
                class="mx-0 px-4 mt-6"
                width="100%"
                color="#ececec"
                v-for="(textItem, textItemIndex) in page2ItemsMB"
                :key="textItemIndex"
                @click="selectedMBCard = textItem"
                :ripple="false"
              >
                <v-row>
                  <v-col
                    lg="12"
                    md="12"
                    cols="12"
                    style="margin-bottom: -40px; margin-top: 15px"
                  >
                    <v-text-field
                      v-if="!textItem.isVariable"
                      v-model="textItem.text"
                      @keydown="_updatePage1MB"
                      @click="_updatePage1MB"
                      :label="textItem.text"
                    >
                    </v-text-field>
                    <v-text-field
                      v-if="!textItem.isVariable"
                      v-model="textItem.textMX"
                      @keydown="_updatePage1MB"
                      @click="_updatePage1MB"
                      label="Монгол тайлбар"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col lg="3" md="3" cols="3">
                    <v-text-field
                      v-model.number="textItem.x"
                      type="Number"
                      @keydown="_updatePage1MB"
                      @click="_updatePage1MB"
                      label="X"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col lg="3" md="3" cols="3">
                    <v-text-field
                      v-model.number="textItem.y"
                      type="Number"
                      @keydown="_updatePage1MB"
                      @click="_updatePage1MB"
                      label="Y"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col lg="3" md="3" cols="3">
                    <v-text-field
                      v-model.number="textItem.fontSize"
                      type="Number"
                      @keydown="_updatePage1MB"
                      @click="_updatePage1MB"
                      label="FontSize"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-btn
                      style="margin-top: 15px; margin-left: -10px"
                      icon
                      @click="
                        _deleteTextItem(ui_setting_page1_mb, textItemIndex)
                      "
                      ><v-icon small>mdi-delete</v-icon></v-btn
                    >
                  </v-col>
                  <div
                    style="display: flex; padding-left: 9px; margin-top: -40px"
                  >
                    <v-checkbox
                      @click="_updatePage1MB"
                      v-model="textItem.isBold"
                      label="isBold"
                      style="margin-right: 10px"
                    ></v-checkbox>
                    <v-checkbox
                      @click="_updatePage1MB"
                      v-model="textItem.isUppercase"
                      label="isUppercase"
                      style="margin-right: 10px"
                    ></v-checkbox>
                    <!-- <v-checkbox
                      @click="_updatePage1MB"
                      v-model="textItem.isVariable"
                      label="isVariable"
                    ></v-checkbox> -->
                  </div>
                  <!-- <div
                    style="display: flex; padding-left: 9px; margin-top: -20px"
                  >
                    <v-text-field
                      v-if="textItem.isVariable"
                      style="padding-right: 5px"
                      :disabled="!textItem.isVariable"
                      v-model="textItem.variableName"
                      @keydown="_updatePage1MB"
                      @click="_updatePage1MB"
                      label="variableName"
                    >
                    </v-text-field>
                    <v-text-field
                      v-if="textItem.isVariable"
                      style="padding-left: 5px"
                      v-model="textItem.nextVariableName"
                      @keydown="_updatePage1MB"
                      @click="_updatePage1MB"
                      label="nextVariableName"
                    >
                    </v-text-field>
                  </div> -->
                </v-row>
              </v-card>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <!-- <DiplomPage2
      id="DiplomPage2"
      :student="student"
      :ui_setting="ui_setting_page2"
      v-if="ui_setting"
    ></DiplomPage2> -->
    <!-- <v-row justify="center">
      <v-btn @click="_print('DiplomPage2')" color="secondary" dark
        >Print2</v-btn
      >
    </v-row> -->
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PrintComponent from "./PrintComponent.vue";
import Page1EN from "./Page1EN.vue";
import Page1MB from "./Page1MB.vue";
import DiplomPage2 from "./DiplomPage2.vue";
import Page2 from "./Page2.vue";
import Page2MX from "./Page2MX.vue";
import Page2EN from "./Page2EN.vue";
import Page2MB from "./Page2MB.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      selectedLanguageType: null,
      ui_setting: {},
      ui_setting_page2: {},
      ui_setting_page1_eng: {},
      ui_setting_page1_mb: { texts: [], fullscreen: true },
      selectedMBCard: null,
    };
  },
  computed: {
    page2Items() {
      return this.ui_setting_page1_eng.texts;
    },
    page2ItemsMB() {
      return this.ui_setting_page1_mb.texts;
    },
  },
  components: {
    PrintComponent,
    DiplomPage2,
    Page2,
    Page2MX,
    Page2EN,
    Page2MB,
    Page1EN,
    Page1MB,
    ...mapState(["userProfile", "currentUser", "xxschoolPath"]),
  },
  created() {
    this.selectedLanguageType = { name: "1. Монгол xэл", languageType: 1 };
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui")
      .onSnapshot((doc) => {
        this.ui_setting = doc.data();
        this.ui_setting.ref = doc.ref;
        this.ui_setting.id = doc.id;
      });
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page2")
      .onSnapshot((doc) => {
        this.ui_setting_page2 = doc.data();
        this.ui_setting_page2.ref = doc.ref;
        this.ui_setting_page2.id = doc.id;
      });

    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page1-mb")
      .onSnapshot((doc) => {
        this.ui_setting_page1_mb = doc.data();
        this.ui_setting_page1_mb.ref = doc.ref;
        this.ui_setting_page1_mb.id = doc.id;
        console.log(this.ui_setting_page1_mb);
      });

    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page1-en")
      .onSnapshot((doc) => {
        this.ui_setting_page1_eng = doc.data();
        this.ui_setting_page1_eng.ref = doc.ref;
        this.ui_setting_page1_eng.id = doc.id;
        console.log(this.ui_setting_page1_eng);
      });
  },

  props: {
    student: {
      required: true,
      type: Object,
    },
  },

  methods: {
    _deleteTextItem(uisett, textItemIndex) {
      var yes = confirm("Та үүнийг устгахад этгэлтэй байна уу?");
      if (yes) {
        uisett.texts.splice(textItemIndex, 1);
        uisett.ref.update(uisett).then(() => {
          console.log("delete", textItemIndex);
        });
      }
    },
    _addNewField(uisett) {
      uisett.texts.push({ text: "NEW_TEXT", x: 10, y: 10, fontSize: 11 });
      uisett.ref.update(uisett).then(console.log("done"));
    },

    _getTranslateString(keyword) {
      if (keyword == "firstName" && this.selectedLanguageType.languageType == 1)
        return this.student.firstName;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.student.firstNameEN;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.student.firstNameMB;
    },
    _updateFullScreen() {
      this.ui_setting.fullscreen = !this.ui_setting.fullscreen;
      this.ui_setting.ref.update(this.ui_setting);
    },

    _updateFullScreenPage2() {
      this.ui_setting_page2.fullscreenPage2 = !this.ui_setting.fullscreenPage2;
      this.ui_setting_page2.ref.update(this.ui_setting);
    },
    _updateMarginPage2() {
      this.ui_setting_page2.ref.update(this.ui_setting_page2);
    },
    _updateMargin() {
      this.ui_setting.ref.update(this.ui_setting);
    },
    _updatePage1EN() {
      console.log(this.page2Items, this.ui_setting_page1_eng.ref.path);
      this.ui_setting_page1_eng.ref.update({ texts: this.page2Items });
    },
    _updatePage1MB() {
      console.log(this.page2ItemsMB, this.ui_setting_page1_mb.ref.path);
      this.ui_setting_page1_mb.ref.update({ texts: this.page2ItemsMB });
    },
    _updatePage1ENFullScreen(setting) {
      setting.fullscreen = !setting.fullscreen;
      setting.ref.update(setting);
    },
    _print(idd) {
      this.selectedMBCard = null;
      // this.$htmlToPaper("printMe");

      const printableElement = document.getElementById(idd);
      setTimeout(() => {
        if (printableElement) {
          const printWindow = window.open();
          printWindow.document.write(
            "<html><head><title>Print</title> <style>@media print {@page {size: landscape;}}</style></head><body>"
          );
          printWindow.document.write(printableElement.innerHTML);
          printWindow.document.write("</body></html>");
          printWindow.document.close();
          printWindow.print();
          printWindow.close();
        }
      },100);
    },
    _print2(idd) {
      const printableElement = document.getElementById(idd);
      var printWindow = window.open();
      printWindow.document.write("<html><head><title>Table Contents</title>");

      //Print the Table CSS.
      var table_style = document.getElementById("table_style").innerHTML;
      printWindow.document.write('<style type = "text/css">');
      printWindow.document.write(table_style);
      printWindow.document.write("</style>");
      printWindow.document.write("</head>");

      //Print the DIV contents i.e. the HTML Table.
      printWindow.document.write("<body>");
      printWindow.document.write(printableElement);
      printWindow.document.write("</body>");
      printWindow.document.write("</html>");
      printWindow.document.close();
      printWindow.print();
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
  }
}
</style>

